import React from "react"
import { useEffect, useState, } from "react"
import { ROUTES } from '../../../utils/api'

import { useSearchParams } from "react-router-dom"

import { Button, Dialog, DialogActions, DialogTitle, Typography } from "@mui/material"

import { useNavigate } from "react-router-dom"
import { AnswersType } from "../Models/AnswersType"
import { useCurrentUser } from "../../../hooks/contexts/currentUserContext"
import { saveEvaluation } from "../../../firebase/databaseApi"
import { evaluationStageType } from "../Models/EvaluationStageType"
import ConfirmationModal from "./ConfirmationModal"

import { QuestionTypes } from "../Models/QuestionTypes"

import { useContext } from "react"
import { PolyglotContext } from "../../../polyglot/polyGlotContext"

interface EndModalProps {
    endAppClicked: boolean
    setEndAppClicked: (exit: boolean) => void
    collectedAnswersCopy: AnswersType
    evaluationStage: evaluationStageType
    collectedAnswers: AnswersType
}

//This modal is for confirming abortion of current evaluation, and exiting back to main app.
const EndModal: React.FC<EndModalProps> = ({ endAppClicked, setEndAppClicked, collectedAnswersCopy, evaluationStage, collectedAnswers }) => {
    const { polyglot } = useContext(PolyglotContext)

    const currentUser = useCurrentUser()
    const customerId = currentUser?.customer?.id

    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const answerType = searchParams.get("type") as QuestionTypes

    //ConfirmationModal Assets
    const [ActivateConfirmationModal, setActivateConfirmationModal] = useState(false);
    const goToHome = () => { navigate(ROUTES.HOME) }

    //Modal Logic
    const [openModal, setOpenModal] = React.useState(false)
    const handleCloseModal = () => {
        setOpenModal(false)
        setEndAppClicked(false)
    }
    useEffect(() => {
        if (endAppClicked) {
            setOpenModal(true)
        }
    }, [endAppClicked])

    const answerCount = Object.keys(collectedAnswersCopy).length

    const handleEndEvaluation = async () => {
        if (customerId) {
            let dataToSend: AnswersType = collectedAnswersCopy

            await saveEvaluation(dataToSend, customerId, evaluationStage, answerType)

            setOpenModal(false);
            setActivateConfirmationModal(true);
        }
    }

    return (
        <>
            <Dialog open={openModal} onClose={handleCloseModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth={false} PaperProps={{ sx: { padding: "3rem" } }}>
                <DialogTitle id="alert-dialog-title">
                    <Typography variant="h1" sx={{
                        border: "solid 3px #41b771",
                        borderRadius: "40px",
                        py: 8,
                        px: 5,
                        width: "100%",
                        textAlign: "center",
                    }}>
                        {polyglot.t("evaluationTool.endModal.h1", { answerCount: answerCount })}
                    </Typography>
                </DialogTitle>
                <DialogActions sx={{ alignItems: "center", justifyContent: "center", mt: "1rem" }}>
                    <Button onClick={handleCloseModal} fullWidth variant="outlined" color="secondary" sx={{ mx: "3rem", fontSize: "2.5rem" }}>
                        {polyglot.t("evaluationTool.endModal.noBtn")}
                    </Button>
                    <Button onClick={handleEndEvaluation} fullWidth variant="contained" color="error" sx={{ mx: "3rem", fontSize: "2.5rem" }}>
                        {polyglot.t("evaluationTool.endModal.yesBtn")}
                    </Button>
                </DialogActions>
            </Dialog >
            <ConfirmationModal textContent={polyglot.t("evaluationTool.endModal.confirmationTextContent", { answerCount: answerCount })} activated={ActivateConfirmationModal} setActivated={setActivateConfirmationModal} setPage={goToHome}></ConfirmationModal>
        </>
    )
}

export default EndModal